import { render, staticRenderFns } from "./KolPlatformInfo.vue?vue&type=template&id=592f2cb1&scoped=true"
import script from "./KolPlatformInfo.vue?vue&type=script&lang=js"
export * from "./KolPlatformInfo.vue?vue&type=script&lang=js"
import style0 from "./KolPlatformInfo.vue?vue&type=style&index=0&id=592f2cb1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "592f2cb1",
  null
  
)

export default component.exports